export default __webpack_public_path__ + "static/media/cm.81d87baa.svg";